const JourneyStrudent = [
  'AI-powered interactive quizzes for dynamic learning experiences.',
  'Efficient automated exams for better preparation and assessment',
  'Instant feedback, track performance, identify strengths and improve with detailed analytics.',
  'Learn anywhere with accessible quiz and exam platforms.',
  'Personalized learning: AI tailors quizzes to your preferences.'
]

export default JourneyStrudent
